// src/pages/HomePage.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Import Components used on the homepage
import WavyDivider from '../components/WavyDivider';
import Hero from '../components/Hero';
import WhyUs from '../components/WhyUs';
import Details from '../components/Details';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Contact from '../components/Contact';

function HomePage() {
   // Define background colors for WavyDivider props
  const bgHero = 'transparent'; // Or var(--bg-hero)
  const bgWhyUs = 'var(--bg-whyus)';
  const bgDetails = 'var(--bg-details)';
  const bgServices = 'var(--bg-services)';
  const bgPortfolio = 'var(--bg-portfolio)';
  const bgContact = 'var(--bg-contact)';
  const bgFooter = 'var(--bg-footer)';

  const location = useLocation(); // Get location object

  // Effect to handle scrolling to hash when location changes (e.g., after navigation)
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const section = document.getElementById(sectionId);

      if (section) {
        const navbarHeight = 70; // Match CSS --navbar-height
        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
        const scrollToPosition = sectionTop - navbarHeight;

        // Delay scrolling slightly to allow DOM to potentially update after navigation
        const timer = setTimeout(() => {
            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth',
            });
        }, 100); // 100ms delay

        return () => clearTimeout(timer); // Cleanup timer
      }
    }
  }, [location]); // Re-run effect when location changes

  return (
    <> {/* Fragment */}
      <Hero />

      <WavyDivider fillColor={bgWhyUs} bgColor={bgHero} waveIndex={1} />
      <section id="why-us">
          <WhyUs />
      </section>

      <WavyDivider fillColor={bgDetails} bgColor={bgWhyUs} waveIndex={1}/>
      <section id="details">
          <Details />
      </section>

      <WavyDivider fillColor={bgServices} bgColor={bgDetails} waveIndex={2}/>
      <section id="services">
          <Services />
      </section>

      <WavyDivider fillColor={bgPortfolio} bgColor={bgServices} waveIndex={1}/>
      <section id="portfolio">
          <Portfolio />
      </section>

      <WavyDivider fillColor={bgContact} bgColor={bgPortfolio} waveIndex={1}/>
      <section id="contact">
          <Contact />
      </section>

      <WavyDivider fillColor={bgFooter} bgColor={bgContact} waveIndex={2}/>
    </>
  );
}

export default HomePage;